module.exports = __webpack_public_path__ + "static/img/permission.fcc1c13.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/permission.png
// module id = w3tf
// module chunks = 0